/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown> }} Retrospective_Month_InvalidInputs */

const en_us2_retrospective_month_invalid = /** @type {(inputs: Retrospective_Month_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That month does not exist: ${i?.month}. Pick another.`)
};

const pt_br2_retrospective_month_invalid = /** @type {(inputs: Retrospective_Month_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esse mês não existe: ${i?.month}. Escolha outro.`)
};

const es_419_retrospective_month_invalid = /** @type {(inputs: Retrospective_Month_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ese mes no existe: ${i?.month}. Elige otro.`)
};

const pt_pt2_retrospective_month_invalid = /** @type {(inputs: Retrospective_Month_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esse mês não existe: ${i?.month}. Escolhe outro.`)
};

const fr_fr2_retrospective_month_invalid = /** @type {(inputs: Retrospective_Month_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ce mois n'existe pas : ${i?.month}. Choisis-en un autre.`)
};

const de_de2_retrospective_month_invalid = /** @type {(inputs: Retrospective_Month_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diesen Monat gibt es nicht: ${i?.month}. Wähle einen anderen.`)
};

const it_it2_retrospective_month_invalid = /** @type {(inputs: Retrospective_Month_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questo mese non esiste: ${i?.month}. Scegline un altro.`)
};

/**
* | output |
* | --- |
* | "That month does not exist: {month}. Pick another." |
*
* @param {Retrospective_Month_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const retrospective_month_invalid = /** @type {((inputs: Retrospective_Month_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Retrospective_Month_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_retrospective_month_invalid(inputs)
	if (locale === "es-419") return es_419_retrospective_month_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_retrospective_month_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_retrospective_month_invalid(inputs)
	if (locale === "de-DE") return de_de2_retrospective_month_invalid(inputs)
	if (locale === "it-IT") return it_it2_retrospective_month_invalid(inputs)
	return en_us2_retrospective_month_invalid(inputs)
});
export { retrospective_month_invalid as "retrospective.month_invalid" }